import { PRICES_GOTTEN } from '../types'
export default (state = {}, action = {}) => {
    switch (action.type) {
        case PRICES_GOTTEN:
            return action.prices;
        default:
            return state;
    }
}